import React from "react";

import { cuesApi } from "../imports";
import { rundownActions } from "../imports";
import { cueDesign } from "./Cue";
import ProBadge from "./snippets/ProBadge";
import { useIsPro } from "../imports";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export default function NewCueButton({
	text,
	cueType,
	css,
	cueOverrides = {},
	bringDirectlyOnAir = false,
	projectId,
	buttonClicked,
	pro = false,
	animated = false,
	animation,
	defaultThemeId,
}) {
	let isPro = useIsPro();

	if (animated) {
		return (
			<div>
				<button
					disabled={pro && !isPro}
					text={text}
					style={{
						backgroundImage: `url(${animation})`,
						backgroundSize: "27rem 15rem",
						backgroundPosition: "center",
					}}
					className={`flex w-40 h-24 ml-2 py-2 mt-3 mb-1 items-center text-left pl-1 whitespace-pre border border-gray-700 transition duration-300 ease-in-out focus:outline-none focus:ring ring-main-500 rounded
				${css}
				${
					!pro
						? "hover:bg-gray-700 cursor-pointer"
						: isPro === true
						? "hover:bg-gray-600 hover:border-gray-600 cursor-pointer"
						: " cursor-auto"
				}
			`}
					icon={faPlus}
					size="small"
					colour="dark"
					onClick={async () => {
						buttonClicked();

						return await cuesApi
							.addCue(
								cueType,
								projectId,
								cueOverrides,
								bringDirectlyOnAir,
								defaultThemeId
							)
							.then((res) => {
								if (!res.data) return null;

								rundownActions.cueToEdit(null, false);
								setTimeout(() => {
									rundownActions.rundownLock(false);
									return rundownActions.cueToEdit(res.data, true);
								}, 200);
							});
					}}
				></button>
				<span className="w-full text-center block text-gray-500 text-sm">
					{text}
				</span>
			</div>
		);
	} else {
		return (
			<button
				disabled={pro && !isPro}
				text={text}
				className={`flex w-full items-center text-left pl-1 pr-8 whitespace-pre border border-gray-700 focus:outline-none focus:ring ring-main-500 rounded
				${css}
				${
					!pro
						? "hover:bg-gray-700 cursor-pointer"
						: isPro === true
						? "hover:bg-gray-700 cursor-pointer"
						: " cursor-auto opacity-50"
				}
			`}
				icon={faPlus}
				size="small"
				colour="dark"
				onClick={async () => {
					buttonClicked();

					return await cuesApi
						.addCue(
							cueType,
							projectId,
							cueOverrides,
							bringDirectlyOnAir,
							defaultThemeId
						)
						.then((res) => {
							if (!res.data) return null;

							if (cueType === "social")
								cuesApi.updateCue(res.data, projectId, {
									chat: { snippet: { displayMessage: "Hi" } },
								});

							rundownActions.cueToEdit(null, false);
							setTimeout(() => {
								rundownActions.rundownLock(false);
								return rundownActions.cueToEdit(res.data, true);
							}, 200);
						});
				}}
			>
				<span
					className={`transform scale-75 flex items-center rounded w-14 ${
						cueDesign(cueType).iconColour
					}`}
				>
					<svg
						width="56"
						height="48"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						{cueDesign(cueType).icon}
					</svg>
				</span>
				<span className="ml-2">
					{text} {pro && <ProBadge />}
				</span>
			</button>
		);
	}
}
